import { useQuery } from '@tanstack/react-query'
import { listCities } from 'supabase/cities'

export const useQueryCities = () => {
  const { isLoading, isError, error, data } = useQuery({
    queryKey: ['cities'],
    queryFn: listCities,
    staleTime: 5 * 60 * 1000,
  })

  return {
    isLoading,
    isError,
    error,
    cities: data,
  }
}
